import React, {FC} from 'react'
import styles from './ProductSearchFilter.module.css'

interface ProductSearchFilterProps {
  searchValue: string
  onSearchChange: (value: string) => void
  onClear: () => void
  totalResults: number
  totalProducts: number
  hasActiveFilter: boolean
}

/**
 * Componente de filtro/pesquisa para produtos
 * Permite buscar por nome, SKU ou valor
 */
export const ProductSearchFilter: FC<ProductSearchFilterProps> = ({
  searchValue,
  onSearchChange,
  onClear,
  totalResults,
  totalProducts,
  hasActiveFilter,
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(e.target.value)
  }

  const handleClearClick = () => {
    onClear()
  }

  return (
    <div className={`${styles.filterContainer}`}>
      {/* Barra de Pesquisa */}
      <div className={`${styles.searchBar}`}>
        <div className={`input-group ${styles.inputGroup}`}>
          <span className={`input-group-text bg-white border-end-0 ${styles.searchIcon}`}>
            <svg width='18' height='18' viewBox='0 0 24 24' fill='none'>
              <path
                d='M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z'
                stroke='#6E7586'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M21.0039 22.0039L18.7539 19.7539'
                stroke='#6E7586'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </span>
          <input
            type='text'
            className={`form-control border-start-0 ${styles.searchInput}`}
            placeholder='Pesquise por nome, SKU ou valor...'
            value={searchValue}
            onChange={handleSearchChange}
            aria-label='Pesquisar produtos'
          />
          {hasActiveFilter && (
            <button
              className={`btn btn-sm btn-light-danger ${styles.clearButton}`}
              onClick={handleClearClick}
              title='Limpar pesquisa'
              type='button'
            >
              <svg width='14' height='14' viewBox='0 0 24 24' fill='none'>
                <path
                  d='M19 5L5 19M5 5L19 19'
                  stroke='#DC3545'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </button>
          )}
        </div>
      </div>

      {/* Informações do Filtro */}
      <div className={`${styles.filterInfo}`}>
        {hasActiveFilter ? (
          <span className={`badge bg-light-info ${styles.resultCount}`}>
            Mostrando <strong>{totalResults}</strong> de <strong>{totalProducts}</strong> produtos
          </span>
        ) : (
          <span className={`badge bg-light-secondary ${styles.resultCount}`}>
            Total: <strong>{totalProducts}</strong> produtos
          </span>
        )}
      </div>
    </div>
  )
}
